import { PropInfo, SectionFactory } from '../components/sections/TextSection';
import { SectionBase } from '../components/sections/SectionBase';
import { DomHelper } from '../utlis/DomHelper';
import { CSS_CLASSES, SELECTORS } from '../constants/CSSClasses';

export class DomManager {
    private static instance: DomManager;
    
    public static getInstance(): DomManager {
        if (!DomManager.instance) {
            DomManager.instance = new DomManager();
        }
        return DomManager.instance;
    }

    private constructor() {}
    public static setZoom(div: HTMLDivElement, scale:[number,number]|null=[1,1]): void {
        if(!scale)
          scale = [1,1];
        if (div) {
          div.style.transform = `scale(${scale[0]},${scale[1]})`; 
          div.style.transformOrigin = "top left"; 
        }
      }
    public createAlignmentLines(host: HTMLElement): { horizontalLine: HTMLElement, verticalLine: HTMLElement } {
        const horizontalLine = document.createElement('div');
        horizontalLine.classList.add('alignment-line', 'horizontal-line');
        horizontalLine.style.display = 'none';

        const verticalLine = document.createElement('div');
        verticalLine.classList.add('alignment-line', 'vertical-line');
        verticalLine.style.display = 'none';

        const viewport = host.querySelector('#viewport-container')!;
        viewport.appendChild(horizontalLine);
        viewport.appendChild(verticalLine);

        return { horizontalLine, verticalLine };
    }

    public toggleElementSelection(element: HTMLElement): void {
        element.classList.toggle('selected');
    }

    public updateElementPosition(element: HTMLElement, left: number, top: number): void {
        element.style.left = `${left}px`;
        element.style.top = `${top}px`;
    }

    public updateElementSize(element: HTMLElement, width: number, height: number): void {
        element.style.width = `${width}px`;
        element.style.height = `${height}px`;
    }
    public getAllElements(): HTMLElement[] {
        return Array.from(document.querySelectorAll('.layout-drag-item'));
    }
    public getSelectedElements(): HTMLElement[] {
        return Array.from(document.querySelectorAll('.layout-drag-item.selected'));
    }
    public getSelectedLockedElements(): HTMLElement[] {
        return Array.from(document.querySelectorAll(SELECTORS.SELECTED_LOCKED_DRAG_ITEM));
    }
    public getLockedElements(): HTMLElement[] {
        return Array.from(document.querySelectorAll(SELECTORS.LOCKED_DRAG_ITEM));
    }
    public getSelectedunlockedElements(): HTMLElement[] {
        return Array.from(document.querySelectorAll(SELECTORS.SELECTED_UNLOCKED_DRAG_ITEM));
    }
    public getUnockedElements(): HTMLElement[] {
        return Array.from(document.querySelectorAll(SELECTORS.UNLOCKED_DRAG_ITEM));
    }
    public clearSelections(excludeId?: string): void {
        document.querySelectorAll('.layout-drag-item').forEach(el => {
            if (!excludeId || el.id !== excludeId) {
                el.classList.remove('selected');
            }
        });
    }

    public createSectionElement(sectionObj: SectionBase, cellWidth: number, cellHeight: number): HTMLElement {
        const element = SectionFactory.createSectionElement();
        
        (element as any)['sectionObj'] = sectionObj;
        element.appendChild(sectionObj.render());
        if(sectionObj.isLocked){
            element.classList.add(CSS_CLASSES.LOCKED);
        }
        this.updateElementSize(element, cellWidth * sectionObj.colCount, cellHeight * sectionObj.rowCount);
        
        sectionObj.propInfo?.forEach((propInfo: PropInfo) => {
            this.applyPropertyToElement(element, propInfo);
        });        

        this.addResizeHandles(element);
        return element;
    }

    public applyPropertyToElement(element: HTMLElement, propInfo: PropInfo): void {
        DomHelper.setBindingValue(
            element,
            propInfo.binding,
            this.getFormattedValue(propInfo.value)
        );
    }

    private getFormattedValue(value: any): any {
        if (!value) return value;
        if (typeof value === 'string' && value.startsWith('rgb')) {
            return DomHelper.rgbToHex(value);
        }
        if (!Number.isNaN(Number(value))) {
            return Number(value) + 'px';
        }
        return value;
    }

    public addResizeHandles(element: HTMLElement): void {
        const handles = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
        handles.forEach(handle => {
            const resizeHandle = document.createElement('div');
            resizeHandle.classList.add('resize-handle', handle);
            element.appendChild(resizeHandle);
        });
    }

    public getElementRect(element: HTMLElement): DOMRect {
        return element.getBoundingClientRect();
    }

    public getViewportContainer(): HTMLElement {
        return document.querySelector('#viewport-container') as HTMLElement;
    }
    public getViewportGridLayerContainer(): HTMLTableElement {
        return document.querySelector('#viewport-container')?.querySelector('.layer-grid') as HTMLTableElement;
    }


    public addElementToContainer(element: HTMLElement): void {
        document.querySelector('.draggable-container')?.appendChild(element);
    }

    public removeElement(element: HTMLElement): void {
        element.remove();
    }

    public updateAlignmentLines(horizontalLine: HTMLElement, verticalLine: HTMLElement, show: boolean, top?: number, left?: number): void {
        if (show) {
            if (top !== undefined) {
                horizontalLine.style.top = `${top}px`;
                horizontalLine.style.display = 'block';
            }
            if (left !== undefined) {
                verticalLine.style.left = `${left}px`;
                verticalLine.style.display = 'block';
            }
        } else {
            horizontalLine.style.display = 'none';
            verticalLine.style.display = 'none';
        }
    }
    
}